import { useContext } from 'react';

import { AvatarContext, type AvatarContextValue } from '@/providers/AvatarProvider';

/** Read/update the signed-in user's avatar URL (see `AvatarProvider`). */
export function useSessionAvatar(): AvatarContextValue {
  const context = useContext(AvatarContext);
  if (!context) {
    throw new Error('useSessionAvatar must be used within an AvatarProvider');
  }
  return context;
}
